import { StationeryTemplateWithThemeJson } from '@apps/card/routes/Dashboard/components/DesignsGallery/useDesignTemplates';
import { StationeryTemplateCategoryEnum, usegetCardDataForImagineQuery } from '@graphql/generated';
import { cloneDeep } from 'lodash-es';
import { useMemo } from 'react';

type useImagineDataProps = {
  themeID: string;
  category: StationeryTemplateCategoryEnum;
};

export const useImagineData = (props: useImagineDataProps) => {
  const { themeID, category } = props;

  const data = usegetCardDataForImagineQuery({
    variables: {
      filter: {
        themeIds: [themeID],
        categories: [category],
      },
    },
    batchMode: 'fast',
  });

  const template: StationeryTemplateWithThemeJson | undefined = useMemo(() => {
    const templateData = data.data?.stationeryTemplatesContainer.pagedResults.edges[0].node;

    if (!templateData) {
      return undefined;
    }

    return cloneDeep({
      ...templateData,
      mappedTags: [],
      isFoil: false,
      format: 'paperAndDigital',
    });
  }, [data]);

  return { loading: data.loading, template };
};
